<template>
  <div id="app" name="app">
    <el-container>
      <div style="position: fixed;z-index: 10;background-color: #FFF;box-shadow: 0 10px 10px -5px rgba(0, 0, 0, 0.1);">
        <div class="mtop" id="mtop">
          <div v-if="drawer == false" style="margin-right: 25.067vw;">
            <img @click="drawer = true" src="./assets/imgs/uploads/mobile/Group 512.png"
              style="width: 5.33vw;height: 2.93vw;" alt="">
          </div>
          <div v-else class="topleft"><img src="./assets/imgs/uploads/mobile/Union.png"
              style="width: 3.92vw;height: 3.92vw;" alt=""></div>
          <el-drawer title="" :modal="false" :size="drawerWidth" direction="ltr" :visible.sync="drawer"
            :with-header="false">
            <div style="overflow: hidden;">
              <div style="margin: 6.267vw 4vw 10.133vw;height: 133.333vw;overflow-y: scroll;">
                <div class="menutitle"><router-link to="/" exact><span>{{
                  $t('menus.home') }}</span></router-link></div>
                  <div class="menutitle">
                  <p @click="togtitbrand3">Products <i style="font-weight: bold;" class="el-icon-arrow-down"></i></p>
                  <div v-show="titlebrand3 == true" style="margin-top: 4.533vw;">
                    <p class="titbdname"><router-link to="/product">Products</router-link></p>
                    <p class="titbdname"><router-link to="/order">Place an order</router-link></p>
                    <p class="titbdname"><router-link to="/howplace">How to place</router-link></p>
                  </div>
                </div>
                <div class="menutitle"><router-link to="/order"><span>{{ $t('menus.quick') }}</span></router-link></div>
                <div class="menutitle"><router-link to="/product">Products</router-link></div>
                <div class="menutitle">
                  <p @click="togtitbrand">Our Brands <i style="font-weight: bold;" class="el-icon-arrow-down"></i></p>
                  <div v-show="titlebrand == true" style="margin-top: 4.533vw;">
                    <p class="titbdname"><router-link to="/ourbrands">About our brands</router-link></p>
                    <p class="titbdname"><router-link to="/exploreGigwi">GiGwi</router-link></p>
                    <p class="titbdname"><router-link to="/exploregp">Gifts for paws</router-link></p>
                    <p class="titbdname"><router-link to="/explorepetgeek">Petgeek</router-link></p>
                    <p class="titbdname"><router-link to="/exploreskipdawg">Skipdawg</router-link></p>
                  </div>
                </div>
                <div class="menutitle">
                  <p @click="togtitbrand1">About Us <i style="font-weight: bold;" class="el-icon-arrow-down"></i></p>
                  <div v-show="titlebrand1 == true" style="margin-top: 4.533vw;">
                    <p class="titbdname"><router-link to="/aboutus">About us</router-link></p>
                    <p class="titbdname"><router-link to="/contactus">Contact us</router-link></p>
                    <p class="titbdname"><router-link to="/faq">FAQ</router-link></p>
                    <p class="titbdname"><router-link to="/events">News and Events</router-link></p>
                  </div>
                </div>
                <div class="menutitle">
                  <p @click="togtitbrand2">Catalog <i style="font-weight: bold;" class="el-icon-arrow-down"></i></p>
                  <div v-show="titlebrand2 == true" style="margin-top: 4.533vw;">
                    <p class="titbdname"><router-link to="/company">GiGwi Catalogue</router-link></p>
                    <p class="titbdname"><router-link to="/catelog">Company profile</router-link></p>
                  </div>
                </div>
                <div v-if="this.$store.getters.getUser" class="menutitle">
                  <router-link to="/Personalcenter/Orderlist">My Profile</router-link>
                </div>
              </div>
            </div>
            <div class="drbottom">
              <div>
                <el-dropdown ref="dropdown" placement="top" @command="handleCommand" :hide-on-click="false">
                  <span class="el-dropdown-link">
                    <div v-if="menuName" @click="toggleDropdown">
                      <span><img style="width: 4vw;height: 4vw;" :src="menuName.img" alt=""></span>
                      <span style="margin-left: 1.6vw;font-weight: bold;color: #333;">{{
                        menuName.value }}</span>
                    </div>
                    <div v-else>
                      <span class="el-dropdown-link">
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                    </div>
                  </span>
                  <el-dropdown-menu slot="dropdown" style="width: 150px;">
                    <el-dropdown-item v-for="item in languages" :key="item.value" :value="item.value" :command="item">
                      <span><img style="width: 4vw;height: 4vw;" :src="item.img" alt=""></span>
                      <span style="margin-left: 1.6vw;">{{ item.value }}</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div v-if="!this.$store.getters.getUser" @click="login"
                style="font-size: 4.267vw;font-weight: bold;color: #000;">Sign Up/Login</div>
              <div v-if="this.$store.getters.getUser" @click="logout"
                style="font-size: 4.267vw;font-weight: bold;color: #000;align-items: center;"><img
                  src="./assets/imgs/uploads/mobile/ic_round-logout.png" style="width: 4.267vw;height: 4.267vw;" alt="">
                Logout</div>
            </div>
          </el-drawer>
          <div style="margin-right: 25.067vw;"><img src="./assets/imgs/uploads/GP logo.png"
              style="width: 24.533vw;height: 6.667vw; object-fit: contain;" alt="">
          </div>
          <div v-if="!this.$store.getters.getUser" @click="login"><img src="./assets/imgs/uploads/mobile/Group 513.png"
              style="width: 4.533vw;height: 4.8vw;" alt=""></div>
          <div v-if="this.$store.getters.getUser" @click="openShoppingCart"><img
              src="./assets/imgs/uploads/mobile/topcart.png" style="width: 5.333vw;height: 5.333vw;" alt=""></div>
          <el-drawer :modal="false" :visible.sync="drawer1" direction="rtl" :size="drawerWidth">
            <div slot="title" style="display: flex;justify-content: space-between;align-items: center;">
              <div>
                <el-checkbox v-model="isAllCheck" style="margin-left: 0.35vw;"></el-checkbox>
                <span style="color: black; font-weight: bold;margin-left: 4vw;font-size: 4.267vw;">Shopping Cart</span>
              </div>
              <span style="margin-right: 4vw;font-size: 3.467vw;">({{ getCheckGoods.length }})Products</span>
            </div>
            <div style="padding: 0 7.733vw;">
              <div v-for="(item, index) in getShoppingCart" :key="item.id"
                style="border-top: 1px solid #EAEAEA;padding:4.267vw 0 4.267vw;display: flex;align-items: center;">
                <el-checkbox :value="item.check" @change="checkChange($event, index)"></el-checkbox>
                <img
                  style="height: 17.067vw; width: 17.333vw; border-radius: 1.333vw; border: 1px solid #D9D9D9;margin-left: 2.4vw;"
                  v-lazy="item.imageUrl" />
                <div style="margin-left: 3.733vw;flexGrow: 1;">
                  <div style="display: flex;justify-content: space-between;font-size: 3.467vw;color: #000;">
                    <p>{{ item.skuName }}</p>
                    <i class="el-icon-delete" @click="deleteData(item.id)" style="margin-left: 4vw;"></i>
                  </div>
                  <p style="color: #959595; font-size: 3.467vw">${{ item.price }}</p>
                  <div style="display: flex;justify-content: space-between;margin-top: 2.667vw;">
                    <el-input-number v-if="item.isLcl === 0" style="width:29.333vw;" :step="item.amount" size="mini"
                      :value="item.num" @change="handleChange($event, index, item.id)" :min="1"
                      step-strictly></el-input-number>
                    <el-input-number v-else style="width:29.333vw;" size="mini" :value="item.num"
                      @change="handleChange($event, index, item.id)" :min="1"></el-input-number>
                    <p style="font-size: 4vw;color: #000;">${{ formatF((item.price * 1000) * item.num / 1000) }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div style="font-size: 12px;padding: 7.733vw;">
              <p style="color: black; font-weight: bold; font-size: 4.533vw">Price Details</p>
              <div style="font-size: 3.467vw;color: #959595;margin-top: 2.667vw;">({{ getShoppingCart.length }}
                Products,{{ getNum }} Pieces)</div>
              <div style="display: flex;justify-content: space-between;margin-top: 2.133vw;color: #959595;">
                <p>Sub-Total</p>
                <p>USD$ {{ getTotalPrice }}</p>
              </div>
              <p style="margin-top: 6.667vw;"><el-button :disabled="isClick" type="primary" @click="send"
                  style="width: 100%">PLACE ORDER</el-button></p>
              <p style="padding:2.933vw 0 17.6vw;text-align: center;">
                <span @click="tocart" style="color: #333;font-size: 4.533vw;">VIEW CART</span>
              </p>
            </div>
          </el-drawer>
        </div>
      </div>
      <!-- 顶部导航栏END -->
      <!-- 登录模块 -->
      <MyLogin></MyLogin>
      <!-- 主要区域容器 -->
      <el-main class="mmain">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </el-main>
      <!-- 主要区域容器END -->
      <!-- 底栏容器 -->
      <el-footer style="height: auto;">
        <div class="mb-footer">
          <div style="width: 65.867vw;height: 13.867vw;display: flex;">
            <img src="./assets/imgs/uploads/logo3.png" style="width: 13.867vw;height: 13.867vw; object-fit: contain;" alt="">
            <p style="width: 47.467vw;margin-left: 4.533vw;font-size: 5.333vw;font-weight: bold;">Best Choice For Your Pet
              Business</p>
          </div>
          <div style="margin-top: 7.2vw;display: flex;align-items: center;">
            <el-input type="text" v-model="stemail" placeholder="Email address..."></el-input>
            <el-button @click="subscription" :disabled="isClick1"
              style="width: 26.133vw;height: 10.4vw;background-color: #CA141D;color: #FFF;font-size: 3.2vw;font-weight: bold;">Subscribe</el-button>
          </div>
          <div style="margin-top: 11.467vw;">
            <div style="display: flex;font-weight: bold;">
              <div style="width: 40vw;">ABOUT US</div>
              <div>Pages</div>
            </div>
            <div style="display: flex;margin-top: 6.4vw;">
              <div style="width: 40vw;"><router-link to="/aboutus">About Us</router-link></div>
              <div><router-link to="/" exact>Home</router-link></div>
            </div>
            <div style="display: flex;margin-top: 6.4vw;">
              <div style="width: 40vw;"><router-link to="/contactus">Contact Us</router-link></div>
              <div><router-link to="/order">Order</router-link></div>
            </div>
            <div style="display: flex;margin-top: 6.4vw;">
              <div style="width: 40vw;"><router-link to="/faq">FAQs</router-link></div>
              <div><router-link to="/product">Products</router-link></div>
            </div>
            <div style="display: flex;margin-top: 6.4vw;">
              <div style="width: 40vw;"></div>
              <div><router-link to="/ourbrands">Brands</router-link></div>
            </div>
          </div>
          <div style="margin: 11.467vw 0 5.867vw;font-weight: bold;">SOCIAL MEDIA</div>
          <div style="display: flex;align-items: center;">
            <a target="_blank" href="https://www.facebook.com/gigwipettoy"><img
                src="./assets/imgs/uploads/ic_baseline-facebook.png"
                style="width: 9.867vw;height: 9.867vw;margin-right: 8.8vw;" alt=""></a>
            <a target="_blank" href="https://twitter.com/PGigwi20003"><img src="./assets/imgs/uploads/mdi_twitter.png"
                style="width: 9.867vw;height: 9.867vw;margin-right: 8.8vw;" alt=""></a>
            <a target="_blank" href="https://www.instagram.com/gigwi_us/"><img
                src="./assets/imgs/uploads/mdi_instagram.png" style="width: 9.867vw;height: 9.867vw;margin-right: 8.8vw;"
                alt=""></a>
            <a target="_blank" href="https://www.youtube.com/channel/UCTuomUE3UbKiXv9bjTAz9Sg"><img
                src="./assets/imgs/uploads/mobile/Vector.png" style="width: 10.133vw;height: 6.933vw;" alt=""></a>
          </div>
          <div class="community">COMMUNITY</div>
          <div style="font-weight: bold;margin-bottom: 2.133vw;">We'd love to hear your feedback !</div>
          <div>Come & join our <span style="text-decoration: underline;">Facebook Group</span></div>
          <div class="copyright">
            <div>
              <p>Copyright © 2025, Gigwi(HK) Trading Co. Limited</p>
              <div style="display: flex;justify-content: space-between;">
                <router-link to="/terms">
                  <p>Terms of Use</p>
                </router-link>
                <router-link to="/policy">
                 <p>Privacy Policy</p> 
                </router-link>
                <p><router-link to="/brandassets">Brand Assets</router-link></p>
              </div>
            </div>
          </div>
        </div>
      </el-footer>
      <!-- 底栏容器END -->
    </el-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

export default {
  metaInfo: {
    title: 'GiGwi - official website | Dog toys ,Cat toys, supplies',
    meta: [
      {
        name: 'description',
        content: 'Welcome to our cat and dog pet toy store! Discover a variety of adorable toys to bring endless fun to your pets. Explore our website to find a wide range of cat and dog toys, including plush toys, teaser wands, and more, catering to different pet preferences.Curated selection of high-quality cat and dog toys, safe and reliable, promoting the healthy and happy growth of your pets.Browse our website and choose the most suitable toys for your beloved pets, allowing them to enjoy more joyful moments.Offering diverse options of cat and dog toys to meet the needs of pets of different ages and breeds, bringing joy and vitality to them.',
      },
      {
        name: 'keywords',
        content: 'GiGwi,Gifts For Paws,PETGEEK,SHIPDAWG,Cat and dog toys, Plush toys,Teaser wands,Pet toy store,Cat and dog supplies,Adorable toys,Pet supplies website,Fun moments,Happy pets,Safe toys',
      },
    ],
  },
  beforeUpdate() {
    this.activeIndex = this.$route.path;
  },
  data() {
    return {
      menuName: {
        value: 'English',
        img: require('./assets/imgs/uploads/English.jpg'),

      },
      isPc: true,
      languages: [
        {
          name: 'en',
          value: 'English',
          img: require('./assets/imgs/uploads/English.jpg'),
        },
        {
          name: 'zh',
          value: '中文(简体)',
          img: require('./assets/imgs/uploads/Chinese.png'),

        }
      ],
      gotop: false,
      value: '',
      isClick: false,
      isClick1: false,
      activeIndex: "", // 头部导航栏选中的标签
      search: "", // 搜索条件
      register: false, // 是否显示注册组件
      visible: false,// 是否退出登录
      highlightedIndex: null, // 选中的文字索引
      drawer: false,
      drawerWidth: '100%', // Drawer宽度
      drawer1: false,
      stemail: '',
      titlebrand: false,
      titlebrand1: false,
      titlebrand2: false,
      titlebrand3: false,
    };
  },
  created() {
    // 获取浏览器localStorage，判断用户是否已经登录
    if (localStorage.getItem("user")) {
      // 如果已经登录，设置vuex登录状态
      this.setUser(JSON.parse(localStorage.getItem("user")));
    }
    // 页面加载时初始化
    // this.updateNavbarVisibility();
  },
  // mounted() {
  //   window.addEventListener("scroll", this.handleScroll, true);
  //   // 绑定滚动事件
  //   this.$el.addEventListener('scroll', this.handleScroll);
  // },
  computed: {
    ...mapGetters([
      "getUser",
      "getNum",
      "getShoppingCart",
      "getCheckNum",
      "getCheckGoods",
      "getTotalPrice",
      "getNum",
    ]),
    userLoggedIn() {
      // 通过 Vuex 的 getter 获取用户登录状态
      return this.$store.getters.getUser !== "";
    },
    isAllCheck: {
      get() {
        return this.$store.getters.getIsAllCheck;
      },
      set(val) {
        this.$store.commit('checkAll', val);
      }
    }
  },
  watch: {
    // 获取vuex的登录状态
    getUser: function (val) {
      if (val === "") {
        // 用户没有登录
        this.setShoppingCart([]);
        this.$router.push({ path: '/' })
      } else {
        // 用户已经登录,获取该用户的购物车信息
        this.$axios
          .post("/api/mall/cart/" + val.id)
          .then(res => {
            if (res.data.code === 200) {
              // 001 为成功, 更新vuex购物车状态
              this.setShoppingCart(res.data.data);
            } else {
              // 提示失败信息
              this.notifyError(res.data.message);
            }
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
    },
    $route() {
      // 路由变化时关闭抽屉
      this.drawer = false;
    },
    // $route() {
    //   this.updateNavbarVisibility();
    // },
  },
  mounted() {
    this.$router.afterEach(() => {
      this.goAnchor("mtop")
    });

  },
  methods: {
    ...mapActions(["setUser", "setShowLogin", "setShoppingCart", "updateShoppingCart", "deleteShoppingCart", "checkAll"]),
    login() {
      // 点击登录按钮, 通过更改vuex的showLogin值显示登录组件
      this.setShowLogin(true);
      this.showContent1 = false;
      this.drawer = false;
      this.drawer1 = false;
    },
    // 退出登录
    logout() {
      this.visible = false;
      // 清空本地登录信息
      localStorage.setItem("user", "");
      // 清空vuex登录信息
      this.setUser("");
      this.notifySucceed(this.$t('prompt.hint3'));
    },
    // 接收注册子组件传过来的数据
    isRegister(val) {
      this.register = val;
    },
    handleCommand(command) {
      this.translate(command.name)
      this.menuName = command
      this.$refs.dropdown.hide(); // Manually close the dropdown menu
    },
    toggleDropdown() {
      if (this.$refs.dropdown.visible) {
        this.$refs.dropdown.hide();
      } else {
        this.$refs.dropdown.show();
      }
    },
    goAnchor(sectionId) {
      var anchor = document.getElementById(sectionId);
      // chrome
      document.body.scrollTop = anchor.offsetTop;
      // firefox
      document.documentElement.scrollTop = anchor.offsetTop;
      // safari
      window.pageYOffset = anchor.offsetTop;
    },
    // 点击搜索按钮
    searchClick() {
      if (this.search != "") {
        // 跳转到全部商品页面,并传递搜索条件
        this.$router.push({ path: "/goods", query: { search: this.search } });
        this.search = "";
      }
    },
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果 
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    translate(lang) {
      this.$i18n.locale = lang
    },
    openShoppingCart() {
      this.drawer1 = true
      // this.$axios.post('', {})
    },
    checkChange(val, key) {
      // 更新vuex中购物车商品是否勾选的状态
      this.updateShoppingCart({ key: key, prop: "check", val: val });
    },
    handleChange(currentValue, key, id) {
      // 当修改数量时，默认勾选
      this.updateShoppingCart({ key: key, prop: "check", val: true });
      // 向后端发起更新购物车的数据库信息请求
      this.$axios
        .post("/api/mall/cart/updateCart", {
          id: id,
          num: currentValue
        })
        .then(res => {
          switch (res.data.code) {
            case 200:
              // 更新vuex状态
              this.updateShoppingCart({
                key: key,
                prop: "num",
                val: currentValue
              });
              break;
            default:
              this.notifyError(res.data.message);
          }
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },
    deleteData(id) {
      var that = this
      this.$confirm(this.$t('cart.del'), this.$t('cart.tip'), {
        confirmButtonText: this.$t('cart.confirm'),
        cancelButtonText: this.$t('cart.think'),
        type: 'warning',
        center: true
      }).then(() => {
        that.deleteItem(id)
      }).catch(() => {
      });
    },
    deleteItem(id) {
      this.$axios
        .post("/api/mall/cart/deleteCart", {
          memberId: this.$store.getters.getUser.id,
          id: id
        })
        .then(res => {
          switch (res.data.code) {
            case 200:
              // “001” 删除成功
              // 更新vuex状态
              this.deleteShoppingCart(id);
              // 提示删除成功信息
              this.notifySucceed(this.$t('cart.deleted'));
              break;
            default:
              // 提示删除失败信息
              this.notifyError(res.data.message);
          }
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },
    send() {
      if (this.getCheckNum > 0) {
        const type = this.$store.getters.getUser.umsType
        if (type !== 0 && this.getTotalPrice < 5000) {
          this.$message({
            showClose: true,
            message: 'You should place order over $5000',
            type: 'warning',
            center: true
          });
        } else {
          this.$router.push({
            path: '/placeorder',
          }),
            this.drawer1 = false
        }
      } else {
        this.isClick = true;
        setTimeout(() => {
          this.isClick = false;
        }, 2000);
        this.$notify({
          message: 'Please select the items.',
          type: 'warning',
          offset: 400
        });
      }
    },
    getLabelForStatus(status) {
      var a = status + ''
      switch (a) {
        case '0':
          return this.$t('list.instock');
        case '1':
          return this.$t('list.production');
        case '2':
          return this.$t('list.ordertogether');
        default:
          return 'unknown';
      }
    },
    formatF(value) {
      let value1 = Math.round(parseFloat(value) * 100) / 100;
      let s = value.toString().split(".");
      if (s.length == 1) {
        value1 = value.toString() + ".00";
        return value1;
      }
      if (s.length > 1) {
        if (s[1].length < 2) {
          value1 = value.toString() + "0";
        }
        return value1;
      }
    },
    tocart() {
      this.$router.push({
        path: '/personalcenter/Cart',
      }),
        this.drawer1 = false
    },
    subscription() {
      this.isClick1 = true;
      setTimeout(() => {
        this.isClick1 = false;
      }, 3000);
      if (this.stemail) {
        this.$axios
          .post("/api/mall/subscription/subscription",
            {
              userId: this.$store.getters.getUser ? this.$store.getters.getUser.id : '',
              userName: this.$store.getters.getUser ? this.$store.getters.getUser.nickName : '',
              email: this.stemail
            })
          .then(res => {
            if (res.data.code === 200) {
              this.$message({
                showClose: true,
                message: 'You will receive a subscription message if you enter the correct email',
                type: 'success',
                center: true
              });
              this.stemail = ''
            } else {
              this.notifyError(res.data.message);
            }
          })
          .catch(err => {
            return Promise.reject(err);
          });
      } else {
        this.$message.error('Please enter email');
      }
    },
    togtitbrand() {
      if (this.titlebrand == false) {
        this.titlebrand = true
        this.titlebrand1 = false
        this.titlebrand2 = false
        this.titlebrand3 = false
      } else {
        this.titlebrand = false
      }
    },
    togtitbrand1() {
      if (this.titlebrand1 == false) {
        this.titlebrand1 = true
        this.titlebrand = false
        this.titlebrand2 = false
        this.titlebrand3 = false

      } else {
        this.titlebrand1 = false
      }
    },
    togtitbrand2() {
      if (this.titlebrand2 == false) {
        this.titlebrand2 = true
        this.titlebrand = false
        this.titlebrand1 = false
        this.titlebrand3 = false
      } else {
        this.titlebrand2 = false
      }
    },
    togtitbrand3() {
      if (this.titlebrand3 == false) {
        this.titlebrand3 = true
        this.titlebrand = false
        this.titlebrand1 = false
        this.titlebrand2 = false
      } else {
        this.titlebrand3 = false
      }
    },
    handleOpen() {
      document.body.style.overflow = 'hidden';
    },
    handleClose() {
      document.body.style.overflow = '';
    }
  }
};
</script>

<style>
.router-link-active,
.active123 {
  color: #CA141D !important;
}

.el-drawer__container ::-webkit-scrollbar {
  display: none;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #333 !important;
  border-color: #959595 !important;
}

.el-footer {
  padding: 0 !important;
}

.mmain {
  margin-top: 53px;
  padding: 0px !important;
}

.el-input__inner:focus {
  border-color: #000 !important;
}

.mtop {
  width: 375px;
  height: 53px;
  position: relative;
  display: flex;
  justify-content: right;
  align-items: center;
  padding: 0 29px;
}

.mtop .el-drawer.ltr {
  top: 53px !important;
}

.mtop .el-drawer.rtl {
  top: 53px !important;
}

.topleft {
  position: absolute;
  left: 10px;
  bottom: -1px;
  width: 51px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px 8px 0 0;
  box-shadow:
    -2px 0 2px -2px rgba(0, 0, 0, 0.2),
    2px 0 2px -2px rgba(0, 0, 0, 0.2),
    0 -2px 2px -2px rgba(0, 0, 0, 0.2);
}

.mb-footer {
  background-color: #F3F3F3;
  padding: 14.133vw 7.733vw 10vw;
  font-size: 16px;
}

.community {
  margin: 44px 0 24px;
  font-weight: bold;
}

.copyright {
  margin-top: 41px;
  display: flex;
  justify-content: center;
  font-size: 12px;
  color: #545454;
}

.menutitle {
  min-height: 78px;
  padding-left: 13px;
  padding-top: 29px;
  font-size: 20px;
  font-weight: bold;
  color: #000;
  border-bottom: 1px solid #EAEAEA;
}

.menutitle:last-child {
  border-bottom: none;
}

.titbdname {
  margin-bottom: 19px;
  color: #565656;
  font-size: 16px;
  font-weight: normal;
}

.drbottom {
  position: absolute;
  padding: 0 29px;
  background-color: #FFF;
  width: 100%;
  bottom: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>